import {
  bloodGroupObject,
  getAgeCalculate,
  filterOptions } from
"@src/helpers/constants";
import { retrieveItem } from "@src/helpers/functions";
import { USER_PROFILE } from "@src/helpers/imagesConstants";
import { useCheckPageComponentAccess } from "@src/hooks/index";
import {
  AppDispatch,
  getSubject,
  getSubjectRequest,
  getSubjectsOrganizationLevels,
  getSubjectsOrganizationLevelsRequest,
  updateSubject,
  updateSubjectClear,
  updateSubjectRequest } from
"@src/redux";
import { Modal, Select, Skeleton, Tooltip, Form, Button } from "antd";
import { startCase } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { VscArrowSwap } from "react-icons/vsc";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

export const LabelInValue = (
label: string,
value?: string,
color?: string | undefined,
loading?: boolean,
ncd?: boolean,
onIconClick?: () => void) =>
{
  return (
    <div className="subject-label">
      <div className="info-label">{`${label}`}</div>
      {loading ? <Skeleton.Button style={{ width: "100px" }} active /> : null}
      {!loading && value &&
      <Tooltip title={value}>
          {ncd && (
        value === "Confirmed DM" ||
        value === "Confirmed HT" ||
        value === "Suspected" ||
        value === "Confirmed DM & HT") ?
        <p className="info-value">
              {value || "-"}{" "}
              {useCheckPageComponentAccess("patient_confirmed_transfer") &&
          <VscArrowSwap
            style={{ marginLeft: 6, cursor: "pointer" }}
            onClick={onIconClick} />}

          
             
            </p> :

        <p className="info-value">{value || "-"}</p>}
        
        </Tooltip>}
      
      {!loading && color &&
      <div className="info-color" style={{ backgroundColor: color }}></div>}
      
    </div>);

};

export const LabelInLevels = (
label: string,
value?: string,
loading?: boolean) =>
{
  return (
    <div className="subject-label">
      <div className="info-label">{`${label}`}</div>
      {loading ? <Skeleton.Button style={{ width: "100px" }} active /> : null}
      {!loading && value &&
      <Tooltip title={value}>
          <p className="info-value">{value || "-"}</p>
        </Tooltip>}
      
    </div>);

};

export const LabelInColor = (
label: string,
color?: string | undefined,
loading?: boolean) =>
{
  return (
    <div className="subject-label">
      <div className="info-label">{`${label}`}</div>
      {loading ? <Skeleton.Button style={{ width: "100px" }} active /> : null}
      {!loading && color &&
      <div className="info-color" style={{ backgroundColor: color }}></div>}
      
    </div>);

};

const SubjectDetailsSidebar: React.FC = () => {
  const ncd = retrieveItem("has_NCD");
  const { t } = useTranslation();
  const { id } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const [ncdValue, setNcdValue] = useState<string | undefined>(undefined);
  const dispatch = useDispatch<AppDispatch>();
  const { result: getDetails, loading: getDetailsLoading } =
  useSelector(getSubject);

  const { result: getSubjectOrganizationLevels } = useSelector(
    getSubjectsOrganizationLevels
  );

  const { result: updateSubjectResult, loading: updateSubjectLoading } =
  useSelector(updateSubject);

  useEffect(() => {
    if (updateSubjectResult?.status === "success") {
      dispatch(updateSubjectClear());
      toast.success(t("subject_updated_successfully"));
      handleClose();
      dispatch(getSubjectRequest({ filter: { id: id } }));
    } else if (updateSubjectResult?.error?.message) {
      toast.error(updateSubjectResult.error.message);
      dispatch(updateSubjectClear());
    }
  }, [updateSubjectResult]);

  useEffect(() => {
    dispatch(
      getSubjectsOrganizationLevelsRequest({
        id: getDetails?.organizationId || ""
      })
    );
  }, [getDetails]);

  const handleNcdConfirmedType = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleSubmit = (values: any) => {
    // const selected: string = values?.ncdConfirmedType || "";
    // set_ncd_value(selected);
    const subjectId: string = id || "";
    dispatch(
      updateSubjectRequest({
        id: subjectId,
        data: { ncdConfirmedType: values?.ncdConfirmedType } as any
      })
    );
    setOpenModal(false);
  };

  useEffect(() => {
    setNcdValue((getDetails as any)?.ncdConfirmedType);
  }, [getDetails]);

  return (
    <div className="subject-details-sidebar">
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center"
        }}>
        
        {getDetailsLoading ?
        <Skeleton.Avatar style={{ width: "100px", height: "100px" }} active /> :

        <img
          src={getDetails?.photo || USER_PROFILE}
          alt="Profile"
          className="subject-profile" />}

        
        {getDetailsLoading ?
        <Skeleton.Input active /> :

        <div className="username">{getDetails?.name}</div>}
        
      </div>
      <hr />
      <div className="info">
        {getDetails?.keyValueList &&
        getDetails?.keyValueList?.length > 0 ?
        <>
            {getDetails?.keyValueList.map((list) => {
            return (
              <>
                  {LabelInValue(
                  list?.organizationSubjectKey?.name || "",
                  list?.value,
                  undefined,
                  getDetailsLoading
                )}
                  <br />
                </>);

          })}
          </> :

        ""}
        
        {LabelInValue(
          "Gender",
          startCase(getDetails?.gender),
          undefined,
          getDetailsLoading
        )}
        <br />
        {LabelInValue(
          "Type",
          startCase(getDetails?.subjectType),
          undefined,
          getDetailsLoading
        )}

        {ncd && <br />}
        {ncd &&
        LabelInValue(
          "NCD",
          `${startCase(
            (ncdValue || getDetails?.ncdConfirmedType || "").
            toLowerCase().
            replace(/_/g, " ")
          ).
          replace(/\bDm\b/g, "DM").
          replace(/\bHt\b/g, "HT").
          replace(/Dm Ht|Ht Dm/gi, "DM & HT")}`,
          undefined,
          getDetailsLoading,
          ncd,
          handleNcdConfirmedType
        )}

        <br />
        {LabelInValue(
          "DOB",
          getDetails?.dob ?
          moment(getDetails?.dob).format("DD-MMM-YYYY") :
          "-",
          undefined,
          getDetailsLoading
        )}
        <br />
        {LabelInValue(
          "Age",
          getDetails?.dob ?
          `${
          Number(getAgeCalculate(getDetails?.dob?.toString() || "")) >
          0 ?
          getAgeCalculate(getDetails?.dob?.toString() || "") :
          "-"}` :

          "-",
          undefined,
          getDetailsLoading
        )}
        <br />
        {LabelInValue(
          "Group",
          bloodGroupObject[getDetails?.bloodGroup || ""],
          undefined,
          getDetailsLoading
        )}
        <br />
        {LabelInValue(
          "Mobile",
          getDetails?.mobile?.Number &&
          `${getDetails?.mobile?.CountryCode} ${getDetails?.mobile?.Number}`,
          undefined,
          getDetailsLoading
        )}
        <br />
        {LabelInValue("Email", getDetails?.email, "", getDetailsLoading)}
        <br />
        {LabelInValue("Address", getDetails?.address, "", getDetailsLoading)}
        <br />
        {LabelInValue(
          "Height",
          getDetails?.subjectMetric?.height,
          undefined,
          getDetailsLoading
        )}
        <br />
        {LabelInValue(
          "Weight",
          getDetails?.subjectMetric?.weight,
          undefined,
          getDetailsLoading
        )}
        <br />
        {LabelInValue(
          "BMI",
          Number(getDetails?.subjectMetric?.bmi).toFixed(2).toString(),
          undefined,
          getDetailsLoading
        )}
        <br />
        {LabelInValue(
          "BSA",
          Number(getDetails?.subjectMetric?.bsa || 0).
          toFixed(2).
          toString(),
          undefined,
          getDetailsLoading
        )}
        <br></br>

        {LabelInColor(
          "Smoker",
          getDetails?.subjectMetric?.isSmoker ? "green" : "red",
          getDetailsLoading
        )}
        <br />
        {LabelInColor(
          "Diabetic",
          getDetails?.subjectMetric?.isDiabetic ? "green" : "red",
          getDetailsLoading
        )}
        <br />
        {LabelInColor(
          "Hypertensive",
          getDetails?.subjectMetric?.isHypertensive ? "green" : "red",
          getDetailsLoading
        )}
        <br></br>
        {Array.isArray(getSubjectOrganizationLevels?.items) &&
        getSubjectOrganizationLevels?.items?.map((item, index) =>
        <React.Fragment key={index}>
              {LabelInLevels(
            item?.level?.name || "-",
            item?.organization?.name || "-",
            getDetailsLoading
          )}
              <br />
            </React.Fragment>
        )}
      </div>

      <Modal
        title={"NCD Update"}
        open={openModal}
        onCancel={handleClose}
        footer={null}>
        
        <Form
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            ncdConfirmedType:
            ncdValue ||
            (getDetails as any)?.ncdConfirmedType ||
            undefined
          }}>
          
          <Form.Item label="NCD Type" name="ncdConfirmedType">
            <Select
              allowClear
              className="filter-select"
              options={filterOptions.ncdConfirmedTypeOptions}
              placeholder={
              <span style={{ color: "black" }}>Select NCD type</span>}

              style={{ width: "100%" }}
              showSearch
              optionFilterProp="label" />
            
          </Form.Item>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </div>
        </Form>
      </Modal>
    </div>);

};

export default SubjectDetailsSidebar;